import React from "react";
import LocationOverviewTab from "../../components/tabs/LocationOverviewTab/LocationOverviewTab";

export default function Locations() {

  return (
    <LocationOverviewTab />
  );
}
